<footer class="footer-area text-center bg-white">
    <p>
        © <span class="text-black fw-semibold">DataSentinel</span> fue desarrollado por <a target="_blank" class="text-primary fw-medium">Informax</a>
    </p>
</footer>